import { motionAllowed } from '../../lib/motion';

/** The app's entrances: quick to arrive, then a long, soft settle (--ease-out). */
const EASE_OUT = 'cubic-bezier(0.16, 1, 0.3, 1)';

/**
 * Rewrite's send-off, as a rewrite starts, however it was asked for: the button's sparkle winds
 * back, then spins and swells and settles, and a ring of light goes out from the button, as the
 * draft's words take flight (word-flight.ts).
 */
export function playSendOff(button: HTMLElement | null): void {
  if (!button || !motionAllowed()) return;
  const icon = button.querySelector('svg');

  // A quarter turn in all, so the star's four points end where they started.
  icon?.animate(
    [
      { transform: 'rotate(0) scale(1)', easing: 'ease-out' },
      { transform: 'rotate(-25deg) scale(0.8)', offset: 0.18, easing: EASE_OUT },
      { transform: 'rotate(110deg) scale(1.35)', offset: 0.6, easing: 'ease-in-out' },
      { transform: 'rotate(90deg) scale(1)' },
    ],
    { duration: 700, composite: 'add' },
  );

  // The ring, outside the button's own shadow, which it keeps.
  const style = getComputedStyle(button);
  const glow = style.getPropertyValue('--accent-glow').trim() || 'rgb(45 212 191 / 32%)';
  const resting = style.boxShadow && style.boxShadow !== 'none' ? `, ${style.boxShadow}` : '';
  button.animate(
    [{ boxShadow: `0 0 0 0 ${glow}${resting}` }, { boxShadow: `0 0 0 14px transparent${resting}` }],
    { duration: 700, easing: EASE_OUT },
  );
}
